import React, { Component, Fragment } from "react";
import KosarLogo from "../../MyFiles/Insurance/LogoLastVersion.png";
import KosarContractNew from "../../MyFiles/Insurance/MyKinsContract1405-1406.pdf";

class Refahi extends Component {
  state = {
    errorMessage: "",
    stepNo: 1,
    isRegister: true,
    selectedRelations: [],
    showConfirmModal: false,
  };
  componentDidMount() {
    this.props.getUserInsRequest(4);
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.userInsRequestJson !== prevProps.userInsRequestJson &&
      this.props.userInsRequestJson && this.props.userInsRequestJson.length > 0
    ) {
      this.setState({
        selectedRelations: this.props.userInsRequestJson.flatMap((x) =>
          x.data_addition.filter((y) => y.NeedEdit === false).map((xx) => xx.Relation_ID) || []
        ),
      });
    }
    else if (
      this.props.userRelationsJson !== prevProps.userRelationsJson &&
      this.props.userRelationsJson && this.props.userRelationsJson.length > 0 &&
      (!this.props.userInsRequestJson ||
        this.props.userInsRequestJson.length === 0)
    ) {
      this.setState({
        selectedRelations: this.props.userRelationsJson.filter((x) => x.NeedEdit === false).map((x) => x.ID),
      });
    }
  }
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleEdit = () => {
    this.props.getAllUserRelation();
    this.setState({ stepNo: 2 });
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleSubmit = () => {
    if (this.state.stepNo === 1) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 2 });
    }
    if (this.state.stepNo === 2) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 3 });
    }
    if (this.state.stepNo === 3) {
      this.submitInsuranceForm();
    }
  };
  toggledecline = () => {
    if (this.state.stepNo === 1) {
      this.setState({ isRegister: !this.state.isRegister });
    }
    if (this.state.stepNo === 2) {
      this.setState({ stepNo: 1 });
    }
    if (this.state.stepNo === 3) {
      this.setState({ stepNo: 2 });
    }
  };
  //selectRelation = (id) => {
  //  if (id !== null) {
  //    var cusid_ele = document.getElementsByClassName("dvRelation");
  //    for (var i = 0; i < cusid_ele.length; ++i) {
  //      var item = cusid_ele[i];
  //      var getValue = $(item).attr("data-target");
  //      if (getValue !== null && getValue.includes(id)) {
  //        item.classList.toggle("active");
  //      }
  //    }
  //  }
  //};
  selectRelation = (id) => {
    this.setState((prevState) => {
      if (prevState.selectedRelations.includes(id)) {
        return {
          selectedRelations: prevState.selectedRelations.filter(
            (x) => x !== id
          ),
        };
      }

      return {
        selectedRelations: [...prevState.selectedRelations, id],
      };
    });
  };


  submitInsuranceForm = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {

      const selectRelationID = this.state.selectedRelations.join(",");
      //var selectRelationID = 0;
      //var cusid_ele = document.getElementsByClassName("dvRelation");
      //for (var i = 0; i < cusid_ele.length; ++i) {
      //  var item = cusid_ele[i];
      //  if (item.classList.contains("active") === true) {
      //    if (selectRelationID === 0) {
      //      selectRelationID = $(item).attr("data-target");
      //    } else {
      //      selectRelationID =
      //        selectRelationID + "," + $(item).attr("data-target");
      //    }
      //  }
      //}
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("tarhRef", 4);
      formdata.append("ID_Relation", selectRelationID);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-insurance`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // this.toggleBlocking();
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              const errorMessage = "درخواست شما با موفقیت در سامانه ثبت شد.";
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
              this.toggleRegister();
              this.props.getUserInsRequest(4);
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      const errorMessage =
        "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  handleRequest = (e) => {
    this.declineInsRequest(e);
  };
  declineInsRequest = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("tarhRef", 4);
      formdata.append("ID_Request", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-ins-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.props.getUserInsRequest(4);
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  render() {
    const confirmedMembers = this.props.userRelationsJson.filter((e) =>
      this.state.selectedRelations.includes(e.ID)
    );
    const excludedMembers = this.props.userRelationsJson.filter(
      (e) => !this.state.selectedRelations.includes(e.ID)
    );

    //const RelationRequierd = this.props.userRelationsJson.filter((x) => this.props.userJson.Gender === true && (x.Relation_ID === 10 || x.Relation_ID === 11)).map((e) =>
    const RelationRequierd = this.props.userRelationsJson.filter((x) => x.RequierPerson).map((e) =>
      e.NeedEdit !== true ? (
        <div
          key={e.ID}
          className={`col-12 mb-2 bg-light dvRelation ${this.state.selectedRelations.includes(e.ID) ? "active" : ""
            }`}
          data-target={e.ID}
        >
          <div className="w-100 rounded p-1">
            <div className="row">
              <div className="col-2 m-auto checkbox">
                {/* <input type="checkbox" /> */}
                <label className="containerCustom">
                  <input
                    type="checkbox"
                    disabled
                    checked={this.state.selectedRelations.includes(e.ID)}
                    value={e.ID}
                    onChange={() => this.selectRelation(e.ID)}
                    name="User Relation Info"
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>
              <div className="col-10">
                <span className="bg-dark text-white wp-text-small rounded p-1">
                  نسبت: {e.Relation_Title}
                </span>{" "}
                <span className="bg-danger text-white wp-text-small rounded p-1 mr-2">
                  اجباری
                </span>
                <div className="title mt-1">
                  <strong>
                    {e.F_Name} {e.L_Name}
                  </strong>
                </div>
                <div className="describe">
                  کدملی: <b>{e.National_Code}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null
    );

    //const Relation_Active = this.props.userRelationsJson.filter((x) => (x.Relation_ID === 1 || x.Relation_ID === 2) || this.props.userJson.Gender === false).map((e) =>
    const Relation_Active = this.props.userRelationsJson.filter((x) => x.RequierPerson === false).map((e) =>
      e.NeedEdit !== true ? (
        <div
          key={e.ID}
          className={`col-12 mb-2 bg-light dvRelation ${this.state.selectedRelations.includes(e.ID) ? "active" : ""
            }`}
          data-target={e.ID}
        >
          <div className="w-100 rounded p-1">
            <div className="row">
              <div className="col-2 m-auto checkbox">
                {/* <input type="checkbox" /> */}
                <label className="containerCustom">
                  <input
                    type="checkbox"
                    checked={this.state.selectedRelations.includes(e.ID)}
                    value={e.ID}
                    onChange={() => this.selectRelation(e.ID)}
                    name="User Relation Info"
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>
              <div className="col-10">
                <span className="bg-dark text-white wp-text-small rounded p-1">
                  جنسیت: {e.Sex}
                </span>{" "}
                <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
                  نسبت: {e.Relation_Title}
                </span>
                <div className="title mt-1">
                  <strong>
                    {e.F_Name} {e.L_Name}
                  </strong>
                </div>
                <div className="describe">
                  کدملی: <b>{e.National_Code}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
        : (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvRelation disable"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <span className="bg-dark text-white wp-text-small rounded p-1">
                جنسیت: {e.Sex}
              </span>{" "}
              <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
                نسبت: {e.Relation_Title}
              </span>
              <div className="title mt-1">
                <strong>
                  {e.F_Name} {e.L_Name}
                </strong>
              </div>
              <div className="describe">
                کدملی: <b>{e.National_Code}</b>
              </div>
              <span className="bg-danger text-white wp-text-small px-2">
                اطلاعات این شخص توسط واحد منابع انسانی تایید نشده است.
              </span>
            </div>
          </div>
        )
    );
    const myRelation = this.props.userRelationsJson.map((e) => (
      <li key={e.ID} className="Array-item readClass">
        <span className="bg-primary text-white wp-text-small rounded p-1">
          جنسیت: {e.Sex}
        </span>{" "}
        <span className="bg-primary text-white wp-text-small rounded p-1 mr-2">
          نسبت: {e.Relation_Title}
        </span>
        <div className="title text-dark mt-1">
          <strong>
            {e.F_Name} {e.L_Name}
          </strong>
        </div>
        <div className="describe">
          کدملی: <b>{e.National_Code}</b>
        </div>
        <div className="describe">
          ش.شناسنامه: <b>{e.Identity_Code}</b>
        </div>
        <div className="describe">
          تاریخ تولد: <b>{e.DateOfBirthday}</b>
        </div>
        <div className="describe">
          محل صدور: <b>{e.Sodor_City}</b>
        </div>
        <div className="text-left">
          <span className={e.State_CSS}>{e.State_Title}</span>
        </div>
        {e.NeedEdit === true ? (
          <Fragment>
            <div className="text-justify">
              <span className="bg-danger text-white wp-text-small">هویت این عضو از خانوار شما توسط واحد منابع انسانی احراز نشده است، با در دست داشتن مدارک به واحد منابع انسانی مراجعه نمایید.</span>
              <div className="text-left mt-2">
                <button
                  type="button"
                  onClick={() => this.props.getUserRelation(e.ID)}
                  className="btn btn-warning btn-sm"
                >
                  ارسال مدارک
                </button>
              </div>
            </div>
          </Fragment>
        ) : null}
      </li>
    ));
    const myRequest = this.props.userInsRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <span className="bg-dark text-white wp-text-small rounded p-1">
          تاریخ درخواست {e.RequestTime}
        </span>
        <div className="title mt-2">
          <strong>{e.Comment}</strong>
        </div>
        <div className="d-grid mb-2">
          <span className="bg-success text-white px-2 py-1 wp-text">
            {e.Start_Date !== null ? (
              <span className="wp-text-small">از </span>
            ) : (
              <span></span>
            )}
            <b>{e.Start_Date}</b>
          </span>
          {e.End_Date !== null ? (
            <span className="bg-danger text-white px-2 py-1 wp-text">
              <span className="wp-text-small">تا </span>
              <b>{e.End_Date}</b>
            </span>
          ) : (
            <span></span>
          )}
        </div>
        <div className="describe">
          تعداد اعضای تحت پوشش: <b>{e.Count}</b>
        </div>
        <div className="describe mt-2">
          {e !== null &&
            e.data_addition !== null &&
            e.data_addition.length > 0 &&
            e.Count > 0
            ? e.data_addition.map((ee) => {
              return (
                <p className="mb-1">
                  <span className="badge bg-success p-2"> </span>{" "}
                  {ee.Relation_Title} - {ee.F_Name} {ee.L_Name} (کدملی{" "}
                  {ee.National_Code})
                </p>
              );
            })
            : null}
        </div>
        <div className="text-left">
          <span className={e.State_CSS}>{e.State_Title}</span>
        </div>
        {e.State === "1" ? (
          <div className="text-left">
            <button
              type="button"
              onClick={() => this.handleRequest(e.ID)}
              className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
            >
              انصراف
            </button>
          </div>
        ) : null}
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <div className="table-responsive">
              <table className="table table-sm text-center">
                <tbody>
                  <tr>
                    <td colSpan="12" className="text-center">
                      <img
                        alt="بیمه کوثر"
                        src={KosarLogo}
                        rel="noopener noreferrer"
                        className="img-64 rounded-circle"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold bg-light">
                      بیمه نامه درمان گروهی 1405 - 1406
                    </td>
                    <td className="font-weight-bold bg-light">
                      <a
                        target="_blank"
                        href={KosarContractNew}
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        مشاهده
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>پنل کاربری بیمه کوثر</td>
                    <td>
                      <a
                        href="https://mykins.ir/MyPanel"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        مشاهده
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>مراکز طرف قرارداد</td>
                    <td>
                      <a
                        href="https://kins.ir/CenterAgreement"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        مشاهده
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="alert alert-warning">
              <p>
                قبل از ثبت درخواست، بیمه نامه درمان گروهی سال جدید را با دقت
                مطالعه نمایید.
              </p>
              <a
                target="_blank"
                href={KosarContractNew}
                rel="noopener noreferrer"
                className="text-decoration-none btn btn-rounded btn-warning"
              >
                مشاهده بیمه نامه
              </a>
            </div>
            <p className="wp-header small">بیمه‌های درمان من</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item" key="0">
                  <div className="title">
                    برای سال 1405 - 1406 هنوز درخواستی برای شما ثبت نشده است.
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            {myRequest.length === 0 ? (
              <button
                onClick={this.toggleRegister}
                className="btn btn-success wp-button-add"
              >
                <span>ثبت درخواست جدید</span>
              </button>
            ) : (
              <button
                onClick={this.toggleEdit}
                className="btn btn-primary wp-button-add"
              >
                <span>ویرایش درخواست</span>
              </button>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      if (this.state.stepNo === 1) {
        return (
          <React.Fragment>
            <div className="container-fluid">
              <div className="row">
                <div className="item body-padding">
                  <p className="wp-header">اعلام شرایط بیمه تکمیلی</p>
                  <div className="row justify-content-center">
                    <p className="text-justify">
                      <span className="bg-dark text-white rounded-pill px-2">
                        1
                      </span>{" "}
                      با توجه به اهمیت جبران هزینه‌های درمان پرسنل و خانواده
                      محترم ایشان قراردادی جامع با شرکت بیمه کوثر منعقد شده است.
                    </p>
                    <p className="text-justify">
                      <span className="bg-dark text-white rounded-pill px-2">
                        2
                      </span>{" "}
                      کلیه پرسنل به عنوان نفر اصلی به صورت پیش فرض (بیمه عمر و
                      حوادث و درمان) ثبت نام خواهند شد.
                    </p>
                    <p className="text-justify">
                      <span className="bg-dark text-white rounded-pill px-2">
                        3
                      </span>{" "}
                      هر شخص می‌تواند افراد تحت تکفل خود شامل پدر، مادر، همسر و
                      فرزندان را با ثبت نام در این سامانه تحت پوشش بیمه مذکور
                      قرار دهد.
                    </p>
                    <p className="text-justify">
                      <span className="bg-dark text-white rounded-pill px-2">
                        4
                      </span>{" "}
                      پدر یا مادر تحت تکفل شامل افرادی است که در سازمان تامین
                      اجتماعی تحت پوشش نفر اصلی قرار گرفته باشند.
                    </p>
                    <p className="font-weight-bold mt-2 mb-1">
                      جدول هزینه‌های ماهانه بیمه تکمیلی کوثر
                    </p>
                    <div className="col-12">
                      <table className="table table-sm table-striped text-center">
                        <thead>
                          <tr className="bg-primary">
                            <th className="text-white">ردیف</th>
                            <th className="text-white">بیمه‌شونده</th>
                            <th className="text-white">شرایط ثبت‌نام</th>
                            <th className="text-white">
                              حق بیمه درمان (ماهانه)
                            </th>
                            <th className="text-white">
                              حق بیمه عمر و حوادث (ماهانه)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>پرسنل اصلی</td>
                            <td>اجباری</td>
                            <td>8,191,121</td>
                            <td>715,000</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>همسر، فرزند</td>
                            <td>اختیاری</td>
                            <td>8,191,121</td>
                            <td>×</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>پدر یا مادر تحت تکفل</td>
                            <td>اختیاری</td>
                            <td>8,191,121</td>
                            <td>×</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>پدر یا مادر غیر تحت تکفل</td>
                            <td>اختیاری</td>
                            <td>12,286,682</td>
                            <td>×</td>
                          </tr>
                          <tr>
                            <td
                              colSpan="12"
                              className="bg-dark text-white text-right"
                            >
                              * کلیه قیمت ها به ریال می‌باشد.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-12 text-left mt-2">
                      <button
                        onClick={this.toggledecline}
                        className="btn btn-danger"
                      >
                        <span>انصراف</span>
                      </button>
                      <button
                        onClick={this.toggleSubmit}
                        className="btn btn-success mr-2"
                      >
                        <span>تایید و مشاهده اعضای خانوار</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 2) {
        return (
          <React.Fragment>
            <div className="container-fluid">
              <div className="row">
                <div className="item body-padding">
                  <div className="alert alert-danger p-2 mt-2">
                    <strong>پیغام!</strong>
                    <p className="text-justify">در صورتی که اطلاعات خانوار شما ناقص است به واحد منابع انسانی مراجعه کنید، برای اضافه کردن عضو جدید بارگذاری شناسنامه و کارت ملی الزامی است.</p>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-12 text-left mb-2">
                      <button
                        onClick={this.toggledecline}
                        className="btn btn-danger"
                      >
                        <span>بازگشت</span>
                      </button>
                      <button
                        onClick={this.toggleSubmit}
                        className="btn btn-success mr-2"
                      >
                        <span>تایید اطلاعات و ادامه</span>
                      </button>
                    </div>
                    <div className="col-12">
                      <ul className="Array p-0 mb-2">
                        {myRelation.length === 0 ? (
                          <li className="Array-item">
                            <div className="title">
                              در صورتی که اطلاعات اعضای خانوار شما در سیستم وجود ندارد، با در دست داشتن مدارک شناسایی به واحد منابع انسانی مراجعه نمایید.
                            </div>
                          </li>
                        ) : (
                          myRelation
                        )}
                      </ul>
                      {/* <div className="text-left mb-2">
                        <button
                          onClick={this.props.toggleRelation}
                          className="btn btn-primary"
                        >
                          <span>+ افزودن خانوار</span>
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 3) {
        return (
          <React.Fragment>
            <div className="container-fluid">
              <div className="row">
                <div className="item body-padding">
                  <p className="wp-header">بیمه شده اصلی</p>
                  <div className="col-12 bg-light dvBasePerson active">
                    <div className="w-100 rounded p-1">
                      <span className="bg-dark text-white wp-text-small rounded p-1">
                        نسبت: نفر اصلی
                      </span>{" "}
                      <span className="bg-danger text-white wp-text-small rounded p-1 mr-2">
                        اجباری
                      </span>
                      <div className="title mt-1">
                        <strong>{this.props.userJson.full_name}</strong>
                      </div>
                      <div className="describe">
                        کدملی: <b>{this.props.userJson.national_id}</b>
                      </div>
                    </div>
                  </div>
                  {RelationRequierd.length === 0 ? (
                    null
                  ) : (
                    <Fragment>
                      <div className="alert alert-warning mt-2 p-1 small text-center">انتخاب همسر و فرزندان برای پرسنل مرد در سازمان اجباری می‌باشد و به صورت پیش فرض انتخاب می شود.</div>
                      {RelationRequierd}
                    </Fragment>
                  )}
                  <div className="alert alert-danger p-2 my-1">
                    <i className="fa fa-info"></i>
                    <strong>پیغام!</strong>
                    <p className="text-justify mb-0">در صورتی که نمی خواهید شخصی از اعضای خانوار شما تحت پوشش بیمه تکمیلی قرار بگیرد از حالت انتخاب خارج کنید.</p>
                  </div>
                  <div className="row justify-content-center">
                    <p className="wp-header">انتخاب سایر اعضا</p>
                    <div className="col-12">
                      <ul className="Array p-0 mb-2">
                        {Relation_Active.length === 0 ? (
                          <li className="Array-item">
                            <div className="title">
                              در صورتی که اطلاعات اعضای خانوار شما در سیستم وجود ندارد، با در دست داشتن مدارک شناسایی به واحد منابع انسانی مراجعه نمایید.
                            </div>
                          </li>
                        ) : (
                          Relation_Active
                        )}
                      </ul>
                      <div className="text-left">
                        <button
                          onClick={this.toggledecline}
                          className="btn btn-danger"
                        >
                          <span>بازگشت</span>
                        </button>
                        <button
                          onClick={() => this.setState({ showConfirmModal: true })}
                          //onClick={this.toggleSubmit}
                          className="btn btn-success mr-2"
                        >
                          <span>ثبت نهایی درخواست</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.showConfirmModal && (
              <div
                className="modal d-block"
                style={{ background: "rgba(0,0,0,0.5)" }}
                tabIndex="-1"
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">تایید نهایی درخواست بیمه تکمیلی</h5>
                    </div>
                    <div className="modal-body">
                      <p className="text-justify">
                        لطفاً قبل از ثبت نهایی، لیست زیر را با دقت بررسی کنید:
                      </p>

                      {/* لیست افرادی که بیمه می‌شوند */}
                      <div className="mb-3">
                        <p className="font-weight-bold text-success mb-2 text-right">
                          <span role="img" aria-label="تایید">✅</span> این افراد تحت پوشش بیمه تکمیلی قرار می‌گیرند:
                        </p>
                        <ul className="list-group">
                          <li className="list-group-item list-group-item-success text-right">
                            <b>{this.props.userJson.full_name}</b> — نفر اصلی (اجباری)
                          </li>
                          {confirmedMembers.map((e) => (
                            <li key={e.ID} className="list-group-item list-group-item-success text-right">
                              <b>
                                {e.F_Name} {e.L_Name}
                              </b>{" "}
                              — {e.Relation_Title}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* لیست افرادی که بیمه نمی‌شوند */}
                      {excludedMembers.length > 0 && (
                        <div className="mb-3">
                          <p className="font-weight-bold text-danger mb-2 text-right">
                            <span role="img" aria-label="رد">❌</span> این افراد تحت پوشش قرار نمی‌گیرند:
                          </p>
                          <ul className="list-group">
                            {excludedMembers.map((e) => (
                              <li key={e.ID} className="list-group-item list-group-item-danger text-right">
                                <b>
                                  {e.F_Name} {e.L_Name}
                                </b>{" "}
                                — {e.Relation_Title}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <div className="alert alert-warning mb-0">
                        آیا از انتخاب خود اطمینان دارید؟
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => this.setState({ showConfirmModal: false })}
                      >
                        بازگشت و اصلاح
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => {
                          this.setState({ showConfirmModal: false });
                          this.submitInsuranceForm();
                        }}
                      >
                        بله، مطمئنم و ثبت کن
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      }
    }
  }
}
export default Refahi;
